import * as S from './styles';
import React from 'react';
import {
  MdFirstPage,
  MdLastPage,
  MdNavigateBefore,
  MdNavigateNext,
} from 'react-icons/md';

interface IPaginationProps {
  currentPage: number;
  paginationSize: number;
  onPageChange: (page: number) => void;
  totalItems: number;
}

export const Pagination: React.FC<IPaginationProps> = ({
  currentPage,
  onPageChange,
  paginationSize,
  totalItems,
}) => {
  const totalPages = Math.ceil(totalItems / paginationSize);

  const isFirstPage = currentPage === 1;
  const isLastPage = currentPage === totalPages || totalPages === 0;

  const handlePageChange = (page: number) => {
    if (page < 1 || page > totalPages) return;
    onPageChange(page);
  };

  const displayedItemsPerPage =
    totalItems < paginationSize ? totalItems : paginationSize;

  return (
    <S.PaginationContainer>
      <S.Pagination>
        <S.Text>Itens por página: {displayedItemsPerPage}</S.Text>
        {totalPages > 0 && (
          <S.Text>
            Página {currentPage} de {totalPages}
          </S.Text>
        )}
        <S.PagButton
          className={isFirstPage ? 'is-disabled' : ''}
          disabled={isFirstPage}
          onClick={() => handlePageChange(1)}
          title="Primeira página"
        >
          <MdFirstPage size={24} />
        </S.PagButton>
        <S.PagButton
          className={isFirstPage ? 'is-disabled' : ''}
          disabled={isFirstPage}
          onClick={() => handlePageChange(currentPage - 1)}
          title="Página anterior"
        >
          <MdNavigateBefore size={24} />
        </S.PagButton>
        <S.PagButton
          className={isLastPage ? 'is-disabled' : ''}
          disabled={isLastPage}
          onClick={() => handlePageChange(currentPage + 1)}
          title="Próxima página"
        >
          <MdNavigateNext size={24} />
        </S.PagButton>
        <S.PagButton
          className={isLastPage ? 'is-disabled' : ''}
          disabled={isLastPage}
          onClick={() => handlePageChange(totalPages)}
          title="Última página"
        >
          <MdLastPage size={24} />
        </S.PagButton>
      </S.Pagination>
    </S.PaginationContainer>
  );
};
